import { IdentityProvider } from 'cio/models/sso-configuration';

export default function externalIdentityProviderLabel(identityProvider: IdentityProvider): string {
  return {
    [IdentityProvider.GoogleOIDC]: 'Google',
    [IdentityProvider.OktaOIDC]: 'Okta',
    [IdentityProvider.AzureOIDC]: 'Azure Active Directory',
    [IdentityProvider.GenericOIDC]: 'Generic OpenID Connect',
  }[identityProvider];
}
